export const light = {
  id: 'light',
  fontStack: 'system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Ubuntu, sans-serif',
  colorWhite: 'rgba(255, 255, 255, 1)',
  colorBlack: 'rgba(0, 0, 0, 1)',
  colorPrimary: 'rgba(39, 100, 255, 1)',
  colorPrimaryDark: 'rgba(13, 54, 140, 1)',
  colorPrimaryText: 'rgba(39, 100, 255, 1)',
  colorSuccess: 'rgba(52, 199, 89, 1)',
  colorError: 'rgba(255, 111, 111, 1)',
  colorErrorDark: 'rgba(220, 39, 39, 1)',
  colorSurface: 'rgba(255, 255, 255, 1)',
  colorBorder: 'rgba(214, 214, 214, 1)',
  colorInputBackground: 'rgba(255, 255, 255, 1)',
  colorControlBackground: 'rgba(0, 0, 0, 0.05)',
  colorText: 'rgba(0, 0, 0, 0.7)',
  colorTextTitle: 'rgba(0, 0, 0, 0.9)',
  colorTextLight: 'rgba(0, 0, 0, 0.54)',
  gradientColors: ['rgba(39, 100, 255, 1)', 'rgba(56, 11, 153, 1)'],
  globeColors: ['#6C80EA', '#6F6ED6', '#725DC1'],
  mobile: 800,
  tablet: 1100,
  outerMargin: 14,
  sheetPadding: 20,
  borderRadius: 6,
  curveFastoutSlowin: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
  curveEaseOutCirc: 'cubic-bezier(0.075, 0.82, 0.165, 1)',
  shadowCard: '0px 4px 12px rgba(0, 0, 0, 0.14), 0px 16px 20px rgba(0, 0, 0, 0.12)',
  shadowPopover: '0px 4px 20px rgba(0, 0, 0, 0.14), 0px 16px 40px rgba(0, 0, 0, 0.12), 0 6px 26px rgba(0, 0, 0, 0.18)',
};

export const dark = {
  id: 'dark',
  fontStack: 'system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Ubuntu, sans-serif',
  colorWhite: 'rgba(255, 255, 255, 1)',
  colorBlack: 'rgba(0, 0, 0, 1)',
  colorPrimary: 'rgba(39, 100, 255, 1)',
  colorPrimaryDark: 'rgba(13, 54, 140, 1)',
  colorPrimaryText: 'rgba(39, 139, 255, 1)',
  colorSuccess: 'rgba(52, 199, 89, 1)',
  colorError: 'rgba(220, 39, 39, 1)',
  colorErrorDark: 'rgba(255, 111, 111, 1)',
  colorSurface: 'rgba(30, 32, 56, 1)',
  colorInputBackground: 'rgba(0, 0, 0, 0.4)',
  colorControlBackground: 'rgba(0, 0, 0, 0.4)',
  colorBorder: 'rgba(0, 0, 0, 0.4)',
  colorText: 'rgba(255, 255, 255, 0.9)',
  colorTextTitle: 'rgba(255, 255, 255, 1)',
  colorTextLight: 'rgba(255, 255, 255, 0.6)',
  gradientColors: ['rgba(11, 13, 28, 1)', 'rgba(11, 13, 28, 1)'],
  globeColors: ['#272836', '#272836', '#272836'],
  mobile: 800,
  tablet: 1100,
  outerMargin: 14,
  sheetPadding: 20,
  borderRadius: 6,
  curveFastoutSlowin: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
  curveEaseOutCirc: 'cubic-bezier(0.075, 0.82, 0.165, 1)',
  shadowCard: '0px 4px 12px rgba(0, 0, 0, 0.28), 0px 16px 20px rgba(0, 0, 0, 0.24)',
  shadowPopover: '0px 4px 20px rgba(0, 0, 0, 0.28), 0px 16px 40px rgba(0, 0, 0, 0.24), 0 6px 26px rgba(0, 0, 0, 0.36)',
};

export default { light, dark };
